"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = void 0;

var _scriptLoader = require("./scriptLoader");

var _promiseOnce = _interopRequireDefault(require("../util/promiseOnce"));

var load = (0, _promiseOnce.default)(function (path, options) {
  return new Promise(function (resolve, reject) {
    (0, _scriptLoader.load)(path, function (event) {
      if (event.type === 'error') {
        var error = new Error("Load ".concat(path, " fail"));
        error.originEvent = event;
        reject(error);
      } else {
        resolve(event);
      }
    }, options);
  });
});
exports.load = load;
//# sourceMappingURL=scriptLoaderPromise.js.map